export default __webpack_public_path__ + "67327bb4c84dc5c5ff6430bc07b8ba4c.svg";